module.exports = __webpack_public_path__ + "static/media/IMG_20150418_180517.6b2c8df1.jpg";